import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
// 封装获取浏览器环境 URL 的方法（避免直接在模块顶层使用 window）
const getBrowserUrl = (path: string) => {
  // 仅在浏览器环境执行（通过判断 typeof window !== 'undefined'）
  if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.host}/${path}`;
  }
  // Node.js 环境兜底（构建阶段用，运行时会覆盖）
  return '';
};

//开发情况
const dev_setting = {
  base: '/',
  API_BASE_URL: '',
  isLocal: false,
  // toolUrl : 'http://localhost:3000',
  toolUrl: 'http://10.33.25.139:8001', //本地连测试环境
  // toolUrl: 'http://10.33.25.139:3001/tool', 
  manualUrl: 'http://10.33.25.139:3001/manual',
  captchaType: 'slider' as const, // 滑块验证
  // captchaType: 'puzzle' as const, // 拼图验证
  defaultTheme: 'businessblue' as const, // 默认主题（grayblue(拂晓蓝-原飞标)/businessblue(商务蓝）
}
//按域名打版
const carevault_setting = {
  base: '/darts/',
  API_BASE_URL: '/darts',
  isLocal: false,
  toolUrl: getBrowserUrl('darts/tool'),
  manualUrl: getBrowserUrl('darts/manual/'),
  // captchaType: 'puzzle' as const, // 拼图验证
  captchaType: 'slider' as const, // 滑块验证
  defaultTheme: 'businessblue' as const, // 默认主题（grayblue(拂晓蓝)/businessblue(商务蓝）
}
//实施项目
const project_setting = {
  ...carevault_setting,
  // base: './', //'/darts/' //其他情况
  isLocal: true,  //是否是本地部署版本，将网络相关取消
}

// const configSetting = dev_setting;
const configSetting=carevault_setting;
// const configSetting=project_setting;
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
  base?: string;
  API_BASE_URL?: string;
  isLocal?: boolean;
  captchaType?: 'slider' | 'puzzle';
  defaultTheme?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '飞标平台',
  pwa: true,
  logo: './logo.png', // 用于个人中心和管理系统
  iconfontUrl: '',
  siderWidth: 180,
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
  base: configSetting.base,
  API_BASE_URL: configSetting.API_BASE_URL,
  isLocal: configSetting.isLocal,
  toolUrl: configSetting.toolUrl,
  manualUrl: configSetting.manualUrl,
  captchaType: configSetting.captchaType || 'slider', // 添加：默认滑块验证
  defaultTheme: configSetting.defaultTheme || 'businessblue', // 部署时配置的默认主题
};

export default Settings;

// 多套主题配置
// 主题配置类型：ProLayoutProps + 自定义 CSS 变量
export type ThemeConfig = ProLayoutProps & {
  cssVars?: Record<string, string>;
};

export const themes: Record<string, ThemeConfig> = {
  grayblue: {
    navTheme: 'light',
    colorPrimary: '#1890ff',
    layout: 'mix',
    siderWidth: 180,
    token: { colorPrimary: '#1890ff' },
    cssVars: {
      '--app-header-bg': '#1c1a1a',  // 顶部导航背景
      '--app-header-color': '#ffffff', // 顶部导航文字
      '--app-header-logo-bg':'#000000', // 顶部导航logo背景
      '--app-header-logo-color':'#ffffff', // 顶部导航logo文字
      '--app-sider-bg': '#c7d0e4', // 侧边栏背景
      '--app-sider-color': '#000000', // 侧边栏文字
      '--app-sider-dynamicmenu-color':'#45484f', // 侧边栏动态菜单文字
      '--app-menu-selected-border': '#1890ff', // 菜单选中左边框
      '--app-menu-selected-bg':'#ffffff', // 菜单选中背景色
      '--app-btn-bg': '#1890ff', // 实心按钮背景色
      '--app-btn-color': '#ffffff', // 实心按钮文字颜色
    },
  },
  businessblue: {
    navTheme: 'light',
    colorPrimary: '#0e5ca8',
    layout: 'mix',
    siderWidth: 180,
    token: { colorPrimary: '#0e5ca8' },
    cssVars: {
      '--app-header-bg': '#ffffff',
      '--app-header-color': '#040c16',
      '--app-header-logo-bg':'#0f5ca8',
      '--app-header-logo-color':'#ffffff',
      '--app-sider-bg': '#0f5ca8',
      '--app-sider-color': '#d9ebff',
      '--app-sider-dynamicmenu-color':'#d9ebff',
      '--app-menu-selected-border': '#3990f4',
      '--app-menu-selected-bg':'#3990f4',
      '--app-btn-bg': '#2168b8', 
      '--app-btn-color': '#ffffff', 
    },
  },
};
